import axios from '@/libs/axios';
import { ErrorMessage } from '@/libs/Error';

export default class SisUsuarioClient {
  constructor() {
    this.api = axios;
    this.error = new ErrorMessage();
  }

  async getItems(queries = {}) {
    try {
      const { data } = await this.api.get('/usuarios/findAll');
      return data;
    } catch (error) {
      throw this.error.message(error, 'Erro ao listar as  Usuario');
    }
  }

  async findByTipoUsuario(usuariotipoid) {
    try {
      const { data } = await this.api.get(`/usuarios/findByTipoUsuario/${usuariotipoid}`);
      return data;
    } catch (error) {
      throw this.error.message(error, 'Erro ao listar as  Usuario');
    }
  }

  async index(queries = {}) {
    try {
      return await this.api.get('/usuarios/findAll', { params: queries });
    } catch (error) {
      throw this.error.message(error, 'Erro ao listar as  Usuario');
    }
  }

  async store(data) {
    try {
      const { data: response } = await this.api.post('/usuarios', data);
      return response;
    } catch (error) {
      throw this.error.message(error, 'Erro ao criar as  Usuario');
    }
  }

  async show(id) {
    try {
      const { data } = await this.api.get(`/usuarios/${id}`);
      return data;
    } catch (error) {
      throw this.error.message(error, 'Erro ao buscar a  Usuario');
    }
  }

  async update(data) {
    try {
      const { data: response } = await this.api.put('/usuarios', data);
      return response;
    } catch (error) {
      throw this.error.message(error, 'Erro ao atualizar a  Usuario');
    }
  }

  async destroy(body) {
    console.log(body);
    try {
      const { data: response } = await this.api.post('/usuarios/delete/', body);
      return response;
    } catch (error) {
      throw this.error.message(error, 'Erro ao deletar a Usuario');
    }
  }
}
